import React from "react";
import logoMark from "../design-system/assets/logo-mark.svg";
import logoMarkMono from "../design-system/assets/logo-mark-mono.svg";

/**
 * AnalyticaY brand lockup.
 * Combines the rising-trend "Y" mark with the wordmark.
 *
 * Props:
 *   - size:   pixel size of the mark (default 32)
 *   - mono:   true to use the monochrome mark (for dark / on-color backgrounds)
 *   - showWordmark: hide the "analyticaY" text if false
 *   - className:  extra classes for the outer wrapper
 *   - wordClassName: extra classes for the wordmark span
 */
export function Logo({ size = 32, mono = false, showWordmark = true, className = "", wordClassName = "" }) {
  return (
    <span
      data-testid="brand-logo"
      className={`inline-flex items-center gap-2 ${className}`}
    >
      <img
        src={mono ? logoMarkMono : logoMark}
        alt="analyticaY"
        width={size}
        height={size}
        style={{ display: "block" }}
      />
      {showWordmark && (
        <span
          className={`font-bold tracking-tight ${wordClassName}`}
          style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: "-0.015em" }}
        >
          analyticaY
        </span>
      )}
    </span>
  );
}

export default Logo;
